// extracted by mini-css-extract-plugin
export default {"Wrapper":"NylasConnect_Wrapper__6yzo5","ConnectForm":"NylasConnect_ConnectForm__ho8Nz","Input":"NylasConnect_Input__3200v"};